import { render, staticRenderFns } from "./CallLogChart.vue?vue&type=template&id=ff3e7a7a&"
import script from "./CallLogChart.vue?vue&type=script&lang=js&"
export * from "./CallLogChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports